"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.refinanceReducer = void 0;
var RefinanceAction_1 = require("@/pages/mortagage/actions/RefinanceAction");
var MortgageCommonReducer_1 = require("@/pages/mortagage/reducers/MortgageCommonReducer");
var RefinanceState_init_1 = require("@/pages/mortagage/states/RefinanceState.init");
exports.refinanceReducer = function (state, action) {
    if (state === void 0) { state = RefinanceState_init_1.defaultRefinanceState; }
    switch (action.type) {
        case RefinanceAction_1.default.ON_OUTSTANDING_MORTGAGE_CHANGED: {
            var outstandingMortgage = action.payload.replace(/[^0-9]+/g, '');
            outstandingMortgage = Math.max(state.outstandingMortgageMin, outstandingMortgage);
            outstandingMortgage = Math.min(state.outstandingMortgageMax, outstandingMortgage);
            return __assign(__assign({}, state), { outstandingMortgage: outstandingMortgage });
        }
        case RefinanceAction_1.default.ON_CURRENT_TENOR_CHANGED: {
            var currentTenor = action.payload;
            return __assign(__assign({}, state), { currentTenor: currentTenor });
        }
        case RefinanceAction_1.default.ON_EXISTING_INTEREST_RATE_CHANGED: {
            var existingInterestRate = action.payload;
            return __assign(__assign({}, state), { existingInterestRate: existingInterestRate });
        }
        case RefinanceAction_1.default.ON_NEW_PROPERTY_VALUE_CHANGED: {
            var newPropertyValue = action.payload.replace(/[^0-9]+/g, '');
            newPropertyValue = Math.max(state.newPropertyValueMin, newPropertyValue);
            newPropertyValue = Math.min(state.newPropertyValueMax, newPropertyValue);
            return __assign(__assign({}, state), { newPropertyValue: newPropertyValue });
        }
        case RefinanceAction_1.default.ON_NEW_LOAN_CHANGED: {
            var newLoan = action.payload.replace(/[^0-9]+/g, '');
            newLoan = Math.max(state.newLoanMin, newLoan);
            newLoan = Math.min(state.newLoanMax, newLoan);
            var newLoanPercent = Math.round(newLoan * 100 / state.newPropertyValue);
            return __assign(__assign({}, state), { newLoan: newLoan,
                newLoanPercent: newLoanPercent });
        }
        case RefinanceAction_1.default.ON_NEW_LOAN_PERCENT_CHANGED: {
            var newLoanPercent = action.payload;
            var newLoan = state.newPropertyValue * newLoanPercent / 100;
            newLoan = Math.max(state.newLoanMin, newLoan);
            newLoan = Math.min(state.newLoanMax, newLoan);
            return __assign(__assign({}, state), { newLoan: newLoan,
                newLoanPercent: newLoanPercent });
        }
        case RefinanceAction_1.default.ON_NEW_TENOR_CHANGED: {
            var newTenor = action.payload;
            return __assign(__assign({}, state), { newTenor: newTenor });
        }
        case RefinanceAction_1.default.ON_NEW_INTEREST_RATE_CHANGED: {
            var newInterestRate = action.payload;
            return __assign(__assign({}, state), { newInterestRate: newInterestRate });
        }
        case RefinanceAction_1.default.SET_RESULT: {
            return __assign(__assign({}, state), { result: action.payload });
        }
    }
    return MortgageCommonReducer_1.mortgageCommonReducer(state, action);
};
